
    (() => {
      const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      let busy = false;
      let lastOpener = null;

      const drawer = () => document.querySelector('cart-drawer');

      const openDrawer = (opener) => {
        const el = drawer();
        if (!el) return;
        lastOpener = opener || lastOpener;
        try {
          if (typeof el.open === 'function') {
            el.open(lastOpener);
            return;
          }
        } catch (error) {
          console.warn('Cart drawer native open failed; using fallback.', error);
        }
        el.classList.add('active');
        document.body.classList.add('overflow-hidden');
        const inner = el.querySelector('.drawer__inner');
        if (inner) inner.focus({ preventScroll: true });
      };

      const closeDrawer = () => {
        const el = drawer();
        if (!el) return;
        try {
          if (typeof el.close === 'function') {
            el.close();
            return;
          }
        } catch (error) {
          console.warn('Cart drawer native close failed; using fallback.', error);
        }
        el.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        if (lastOpener) lastOpener.focus({ preventScroll: true });
      };

      const sectionDocument = (html) => new DOMParser().parseFromString(html, 'text/html');

      const renderCart = (payload) => {
        if (!payload || !payload.sections) return;

        const drawerMarkup = payload.sections['cart-drawer'];
        if (drawerMarkup) {
          const nextDrawer = sectionDocument(drawerMarkup).querySelector('cart-drawer');
          const currentDrawer = drawer();
          if (nextDrawer && currentDrawer) currentDrawer.innerHTML = nextDrawer.innerHTML;
        }

        const bubbleMarkup = payload.sections['cart-icon-bubble'];
        if (bubbleMarkup) {
          const nextBubble = sectionDocument(bubbleMarkup).querySelector('#cart-icon-bubble');
          const currentBubble = document.querySelector('#cart-icon-bubble');
          if (nextBubble && currentBubble) currentBubble.innerHTML = nextBubble.innerHTML;
        }

        decorateUpsells();
        requestAnimationFrame(() => openDrawer(lastOpener));
      };

      const requestCart = async (path, body) => {
        const response = await fetch(root() + path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(Object.assign({}, body, {
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          }))
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to update cart.');
        renderCart(payload);
        return payload;
      };

      const showError = (message) => {
        const target = document.querySelector('#CartDrawer-CartErrors');
        if (target) target.textContent = message;
      };

      const chosenUpsellVariant = (upsell) => {
        const fallback = Number(upsell.dataset.id);
        const data = upsell.querySelector('script[type="application/json"]');
        if (!data) return fallback;
        try {
          const variants = JSON.parse(data.textContent);
          const values = Array.from(upsell.querySelectorAll('select.variant-dropdown')).map((select) => select.value);
          const match = variants.find((variant) => values.every((value, index) => variant.options[index] === value) && variant.available);
          return match ? Number(match.id) : fallback;
        } catch (error) {
          return fallback;
        }
      };

      const decorateUpsells = () => {
        document.querySelectorAll('.cart-drawer cart-drawer-upsell').forEach((upsell) => {
          const button = upsell.querySelector('.upsell-toggle-btn, .upsell__toggle-switch');
          if (!button) return;
          const title = (upsell.querySelector('.upsell__title h3') || {}).textContent || 'upsell';
          const selected = upsell.dataset.selected === 'true';
          button.type = 'button';
          button.setAttribute('aria-pressed', String(selected));
          button.setAttribute('aria-label', (selected ? 'Remove ' : 'Add ') + title.trim());
        });
      };

      document.addEventListener('click', async (event) => {
        const cartTrigger = event.target.closest('.header__icon--cart');
        if (cartTrigger && drawer()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openDrawer(cartTrigger);
          return;
        }

        const closeTrigger = event.target.closest('.cart-drawer .drawer__close, #CartDrawer-Overlay');
        if (closeTrigger) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeDrawer();
          return;
        }

        const quantityButton = event.target.closest('.cart-drawer .quantity__button');
        if (quantityButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (busy || quantityButton.disabled || quantityButton.classList.contains('disabled')) return;
          const control = quantityButton.closest('quantity-input');
          const input = control && control.querySelector('.quantity__input');
          if (!input) return;
          const current = Number(input.value) || 0;
          const step = Number(input.step) || 1;
          const minimum = Number(input.min) || 0;
          const next = quantityButton.name === 'plus' ? current + step : Math.max(minimum, current - step);
          if (next === current) return;
          busy = true;
          control.setAttribute('aria-busy', 'true');
          try {
            await requestCart('cart/change.js', { line: Number(input.dataset.index), quantity: next });
          } catch (error) {
            showError(error.message);
          } finally {
            busy = false;
            control.removeAttribute('aria-busy');
          }
          return;
        }

        const upsellButton = event.target.closest('.cart-drawer .upsell-toggle-btn, .cart-drawer .upsell__toggle-switch');
        if (upsellButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (busy) return;
          const upsell = upsellButton.closest('cart-drawer-upsell');
          if (!upsell) return;
          const variantId = chosenUpsellVariant(upsell);
          if (!variantId) return;
          busy = true;
          upsell.setAttribute('aria-busy', 'true');
          try {
            if ((await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json())).items.some((item) => Number(item.variant_id) === variantId)) {
              const cartResponse = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
              const cart = await cartResponse.json();
              const line = cart.items.findIndex((item) => Number(item.variant_id) === variantId);
              if (line >= 0) await requestCart('cart/change.js', { line: line + 1, quantity: 0 });
            } else {
              await requestCart('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
              const renderedUpsell = Array.from(document.querySelectorAll('.cart-drawer cart-drawer-upsell')).find((item) => chosenUpsellVariant(item) === variantId);
              if (renderedUpsell) {
                renderedUpsell.dataset.selected = 'true';
                decorateUpsells();
              }
            }
          } catch (error) {
            showError(error.message);
          } finally {
            busy = false;
            upsell.removeAttribute('aria-busy');
          }
        }
      }, true);

      document.addEventListener('change', (event) => {
        const select = event.target.closest('.cart-drawer cart-drawer-upsell select.variant-dropdown');
        if (!select) return;
        const upsell = select.closest('cart-drawer-upsell');
        const variantId = chosenUpsellVariant(upsell);
        if (variantId) upsell.dataset.id = String(variantId);
      }, true);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', decorateUpsells, { once: true });
      } else {
        decorateUpsells();
      }
    })();
  